import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AppStorage } from '@app/common/services/data-api/app-storage.service';
import { MenuService } from '@app/common/services/menu.service';
import { PlexEnvironment } from '@app/env';
import { kendoIcons } from '@app/shared/library/kendo-icons';
import { MenuItem } from '@app/shared/models/menu-item';
import { SVGIconComponent } from '@progress/kendo-angular-icons';
import { ThemeObject } from 'environments/env-name';
import { EnvThemeService } from '../../services/env-theme.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
    RouterLinkActive,
    SVGIconComponent,
  ],
})
export class SidebarComponent implements OnInit {
  private menuService = inject(MenuService);
  private router = inject(Router);
  private envThemeService = inject(EnvThemeService);
  private store = inject(AppStorage);
  public environment = inject(PlexEnvironment);

  public icons = kendoIcons;

  public menuMasterList: MenuItem[];
  public menuItems: MenuItem[];

  public target: number = null;

  public navLookup: Array<string> = [];

  public childLookup: any[] = [];

  public envName: string;
  public bgColor1: {};
  public bgColor2: {};
  public envTheme: ThemeObject;
  public homeRouteUrl: string;

  constructor() {
    this.homeRouteUrl = this.environment.spmAppUrl;
  }

  public ngOnInit() {
    this.envTheme = this.envThemeService.getEnvStyle();
    this.envName = this.envTheme.envName;
    if (this.envTheme.themeColors.length > 0) {
      this.bgColor1 = this.envTheme.themeColors[0];
    } else {
      this.bgColor1 = null;
    }

    this.menuService.getAllAsync().subscribe(m => {
      this.menuItems = m;
    })
  }

  public hide() {
    this.target = null;
  }

  public show(ele) {
    this.target = ele;
  }

  public ngAfterViewInit() {
    this.store.knownEvents.assetTeamSelected.subscribe(selected => {
      if (!selected) return;

      const parentState = this.menuService.currentParent?.state ?? '';
      const childState = this.menuService.currentChild?.state ?? '';
      const currentRoute = `${parentState}/${childState}`;
      const targetParent = this.menuItems[0];
      const targetChild = targetParent?.children?.[0];

      const validRoutes = ['projects/project-teams', 'admin/bulk-project-updates'];
      if (validRoutes.includes(currentRoute) ) {
        this.menuLinkClicked(targetParent, targetChild);
        this.router.navigate(['/', targetParent.state, targetChild.state]);
      }
    });
  }

  public menuLinkClicked(parent: MenuItem, child: MenuItem) {
    this.menuService.currentParent = parent;
    this.menuService.currentChild = child;
  }
}